import { Route, Routes } from "react-router-dom";
import { Overview } from './Overview';
export const ChecksRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Overview />} />
    </Routes>
  );
}
